import { getValueRuleGroups } from './configurationAdminUtils';
import { getPartMatchRuleGroups } from './partAutoSelectUtils';
import { getPumpCellContextSelections, isPartRuleGroupRelatedToCell } from './pumpAssignmentUtils';

const isHC = label => /^(hc\b|horizontal centrifugal\b)/i.test(String(label || '').trim());
export const getPumpCategoryCode = label => isHC(label) ? '122'
  : /^(submersible\b|sub\b|subm\b|st\b)/i.test(String(label || '').trim()) ? '120' : null;
const typeContext = (selections, label) => ({ selections, isHC: isHC(label), allowedCategoryCode: getPumpCategoryCode(label) });
export const getPumpTableTypeContext = (station, source = {}, model = {}, cell) => {
  const values = source.fieldValues || [];
  const fields = (source.fields || []).filter(field => /^(type|pump type)$/i.test(String(field.fieldName || '').trim()))
    .sort((a, b) => Number(/^pump type$/i.test(b.fieldName.trim())) - Number(/^pump type$/i.test(a.fieldName.trim())));
  const selections = getPumpCellContextSelections(source.fieldValues ? source : null, station.id, cell, model.fieldIds || {});
  if (model.pumpTypeValueId) {
    const value = values.find(item => item.id === model.pumpTypeValueId);
    if (value) selections[value.configFieldId] = value.id;
    return typeContext(selections, model.pumpTypeLabel || value?.optionValue);
  }
  for (const field of fields) {
    const selected = values.find(value => value.id === selections[field.id]);
    if (selected && getPumpCategoryCode(selected.optionValue)) return typeContext(selections, selected.optionValue);
    const ids = new Set(values.filter(value => value.configFieldId === field.id).map(value => value.id));
    const assigned = [...new Set(getValueRuleGroups(source.valueRules || [], station.id, ids).flatMap(group => group.values.map(value => value.fieldValueId)))];
    if (assigned.length === 1) {
      const label = values.find(value => value.id === assigned[0])?.optionValue;
      if (getPumpCategoryCode(label)) {
        selections[field.id] = assigned[0];
        return typeContext(selections, label);
      }
    }
  }
  return typeContext(selections, station.stationName);
};

export const isPartInCategory = (part, categories, code) => categories.some(category => category.id === part?.categoryId && String(category.code).trim() === String(code));
export const isCategory122Part = (part, categories) => isPartInCategory(part, categories, '122');

export const hasPumpCellRule = (data, station, source, model, cell, hpValue) => {
  if (!data) return false;
  const type = getPumpTableTypeContext(station, source, model, cell);
  if (!type.allowedCategoryCode) return false;
  const context = { fieldIds: model.fieldIds, selections: type.selections, cell: { ...cell, hpValueIds: [hpValue.id], hpValues: [hpValue] } };
  const ranges = { [model.fieldIds.gpm]: [cell.gpmMin, cell.gpmMax], [model.fieldIds.dischargePsi]: [cell.psiMin, cell.psiMax] };
  return data.parts.filter(part => isPartInCategory(part, data.categories, type.allowedCategoryCode) && data.assignments.some(row => row.stationId === station.id && row.partId === part.id))
    .some(part => getPartMatchRuleGroups(data.rules, part.id, station.id).some(group =>
      isPartRuleGroupRelatedToCell(group, context, source.fieldValues || []) && group.conditions.every(rule => {
        const value = rule.requiredValueId && (source.fieldValues || []).find(item => item.id === rule.requiredValueId);
        if (rule.requiredValueId && !value) return false;
        const range = ranges[value ? value.configFieldId : rule.fieldId];
        if (!range) return true;
        const min = value ? Number(value.minValue ?? value.optionValue) : rule.minValue ?? -Infinity;
        const max = value ? Number(value.maxValue ?? value.optionValue) : rule.maxValue ?? Infinity;
        return min <= range[0] && max >= range[1];
      })));
};
export const hasHcPumpCellRule = (data, station, source, model, cell, hpValue) => getPumpTableTypeContext(station, source, model, cell).isHC && hasPumpCellRule(data, station, source, model, cell, hpValue);
